module.exports = __webpack_public_path__ + "static/media/FE2100-51E_01.148bfcc4.png";